import React from 'react';
import Select from '../../form/Select';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import TextInput from "../../form/TextInput";
import {CurrencyFormatter, PercentFormatter, UnitFormatter} from "../../../utils/formatters";
import BigNumber from "bignumber.js";

class RoyaltyRangeForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-4 percent">
                        <TextInput
                            type="decimal"
                            name="amount"
                            label="Százalék"
                            formatter={PercentFormatter}
                            value={this.props.values.amount && this.props.values.amount + "" !== "0." ? new BigNumber(this.props.values.amount).multipliedBy(100).toNumber() : this.props.values.amount}
                            {...this.props.getFieldProps("amount")}
                            saveChanges={(field, value) => this.props.setFieldValue(field, value && value + "" !== "0." ? new BigNumber(value).dividedBy(100).toNumber() : value)}
                        />
                    </div>
                    <div className="col-sm-4 unit">
                        <TextInput
                            type="number"
                            name="limit"
                            label="Alsó küszöb"
                            value={this.props.values.limit}
                            {...this.props.getFieldProps("limit")}
                            formatter={UnitFormatter}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(RoyaltyRangeForm);
